<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">FAQ - List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                  color="primary"
                  class="float-left mb-2 ml-3"
                  @click="faqCreate"
              >Create
              </CButton
              >
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                      class="float-left mb-0 mr-2"
                      placeholder="Search By Question"
                      @input="onSearch"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass"/>
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="100"
              clickable-rows
              :active-page="1"
              :pagination="false"
              @page-change="pageChange"
          >
            <template #program_type="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-1"
                      @click="rowClicked(data.item.faq_id)"
                  >Edit
                  </CButton
                  >
                  <CButton
                      color="danger"
                      class="mb-0 mr-0"
                      @click="updateFaq(data.item.faq_id)"
                  >Delete
                  </CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="searchFAQ('', 'REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="searchFAQ('', 'BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="searchFAQ('', 'NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import FAQUseCase from "./app/usecase";
import jwt from "jsonwebtoken";

export default {
  name: "Program",
  data() {
    return {
      items: [],
      fields: [
        {key: "faq_id", label: "ID"},
        {key: "priority", label: "Priority"},
        {key: "category", label: "Category"},
        {key: "topic", label: "Topic", _classes: "topic-class"},
        {key: "question", label: "Question", _classes: "question-class"},
        {key: "program_type", label: "Action"},
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      debounce: {
        timeout: 0,
        duration: 1800,
      }
    };
  },
  mounted() {
    this.authentication();
    this.searchFAQ("", "");
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "NPOS" ||
          data.account_group === "QC" ||
          data.account_group === "COMMUNITY" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({path: `/`});
      }
    },
    async onSearch(val) {
      try {
        if (this.debounce.timeout) {
          clearTimeout(this.debounce.timeout)
        }
        this.debounce.timeout = setTimeout(async () => {
          await this.searchFAQ(val)
        }, this.debounce.duration)
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err || "something went wrong",
        });
      }

    },
    async searchFAQ(event, action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      try {
        const resp = await FAQUseCase.getAll(`page=${this.activePage}&per_page=20&q=${event}`)
        if (resp.data && resp.data.length > 0) {
          if (this.activePage > 1) {
            window.scrollTo(0, 0);
          }
          this.items = resp.data;
        } else if (action === "NEXT") {
          this.activePage = this.activePage - 1;
        } else if (resp.data.length === 0 && action === "") {
          this.items = resp.data;
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.err || "something went wrong",
        });
      }
    },
    /** @param faqID {number} */
    updateFaq(faqID) {
      this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          FAQUseCase.setStatusInactive(faqID)
              .then(resp => {
                this.$swal.fire({
                  icon: "success",
                  title: `FAQ Deleted ` + resp.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.searchFAQ("", "")
              }).catch(err => {
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Some Data Is missing or invalid " + JSON.stringify(err),
            });
          })
        }
      });
    },
    rowClicked(item) {
      this.$router.push({path: `/management/faq/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    faqCreate() {
      this.$router.push({path: `/management/faq/create`});
    },
  },
  beforeDestroy() {
    clearTimeout(this.debounce.timeout)
  }
};
</script>

<style scoped>
@import url("./Faq.css");

/deep/ .topic-class {
  text-transform: capitalize;
}

/deep/ .question-class {
  width: 50%;
}
</style>
